// @ts-nocheck

let fbqReady = false;

declare global {
	interface Window {
		fbq?: {
			(method: string, ...args: unknown[]): void;
			callMethod?: (...args: unknown[]) => void;
			queue?: unknown[];
			loaded?: boolean;
			version?: string;
			push?: unknown;
		};
		_fbq?: unknown;
	}
}

export function metaPixel(userConfig = {}) {
	const config = {
		options: { autoConfig: true, debug: false },
		...userConfig,
	};

	return {
		name: 'meta-pixel-facebook-ads',
		config,

		/**
		 * Injects Facebook Pixel script and initializes the pixel
		 */

		// biome-ignore lint/suspicious/noExplicitAny: should be any
		initialize: ({ config }: { config: { pixelId: string; options: Record<string, any> } }) => {
			const { pixelId, options } = config;
			if (!pixelId || fbqReady) return;

			/* Load standard Facebook Pixel script */
			!((f, b, e, v, n, t, s) => {
				if (f.fbq) return;
				// biome-ignore lint/style/noParameterAssign: it is what it is
				n = f.fbq = (...args) => {
					n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
				};
				if (!f._fbq) f._fbq = n;
				n.push = n;
				n.loaded = !0;
				n.version = '2.0';
				if (config.nonce) {
					n.nonce = config.nonce;
				}
				n.queue = [];
				// biome-ignore lint/style/noParameterAssign: it is what it is
				t = b.createElement(e);
				t.async = !0;
				t.src = v;
				// biome-ignore lint/style/noParameterAssign: it is what it is
				s = b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t, s);
			})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

			/* Initialize Pixel */
			// @ts-ignore
			window.fbq('init', pixelId, options);
			fbqReady = true;
		},

		/**
		 * Track a page view
		 */
		page: () => {
			if (!fbqReady) return;
			// @ts-ignore
			window.fbq('track', 'PageView');
		},

		/**
		 * Track a custom event
		 */

		// biome-ignore lint/suspicious/noExplicitAny: should be any
		track: ({ payload }: { payload: { event: string; properties: Record<string, any> } }) => {
			if (!fbqReady) return;
			const { event, properties } = payload;
			// @ts-ignore
			window.fbq('track', event, properties);
		},

		/**
		 * Identify a user (no-op, FB Pixel doesn't support identify)
		 */
		identify: () => {},

		/**
		 * Return whether the pixel script has loaded
		 */
		loaded: () => fbqReady,
	};
}
